export const INVALIDATE_RIPPLES = `
    mutation invalidateRipples($organization: String!, $ids: [String]!) {
        invalidateRipples(
        input: { clientMutationId: "1", organization: $organization, ids: $ids }
        ) {
        clientMutationId
        }
    }
`